import _ from "lodash";

import { getColumnFilters } from "@dashboard/shared/Filtering.utils";
import { Table } from "@tanstack/react-table";

import { DeviceTableData } from "../DeviceTable.utils";

export const columnFilter = (row: { getValue: (columnId: string) => string }, columnId: string, filterValue: string[]) => {
    const value = row.getValue(columnId);
    return filterValue.includes(value);
};

export const getInitialOnlineStatusFilters = (table: Table<DeviceTableData>) => {
    const filters = getColumnFilters("onlineStatus", table);
    return {
        Online: filters.includes("Online"),
        Offline: filters.includes("Offline"),
    };
};

export const getInitialLicenseStatusFilters = (table: Table<DeviceTableData>) => {
    const filters = getColumnFilters("licenseStatus", table);
    return {
        Used: filters.includes("Used"),
        Unused: filters.includes("Unused"),
    };
};

export const getInitialWarningsFilters = (table: Table<DeviceTableData>): { OK: boolean; Warning: boolean } => {
    const filters = getColumnFilters("warnings", table);
    return {
        OK: filters.includes("OK"),
        Warning: filters.includes("Warning"),
    };
};

export const getInitialSystemVersionFilters = (table: Table<DeviceTableData>) => {
    const filters = getColumnFilters("systemVersion", table);
    const versions = _.uniq(_.compact(table.getCoreRowModel().rows.map((row) => row.original.systemVersion)));
    return Object.fromEntries(versions.map((version) => [version, filters.includes(version)]));
};

export const getInitialCodenameFilters = (table: Table<DeviceTableData>) => {
    const filters = getColumnFilters("codename", table);
    const codenames = _.uniq(_.compact(table.getCoreRowModel().rows.map((row) => row.original.codename)));
    return Object.fromEntries(codenames.map((codename) => [codename, filters.includes(codename)]));
};

const _DeviceFilterTypes = [
    "licenseStatus",
    "onlineStatus",
    "policyStatus",
    "groupName",
    "systemVersion",
    "codename",
    "warnings",
] as const;

export type DeviceFilterType = (typeof _DeviceFilterTypes)[number];
